import Action from './Action.vue';
import FormAction from './FormAction.vue';
import Page from './Page.vue';
import Section from './Section.vue';
import ConditionalSection from './ConditionalSection.vue';
import Question from './Question.vue';
import UnknownItem from './UnknownItem.vue';
import { INSPECTION_ITEM_TYPE } from '@/_legacy/constants';

export default {
  functional: true,
  render(h, { props }) {
    let item;
    switch (props.item.type) {
      case INSPECTION_ITEM_TYPE.PAGE:
        item = Page;
        break;
      case INSPECTION_ITEM_TYPE.SECTION:
        item = Section;
        break;
      case INSPECTION_ITEM_TYPE.CONDITIONAL:
        item = ConditionalSection;
        break;
      case INSPECTION_ITEM_TYPE.QUESTION:
        item = Question;
        break;
      case INSPECTION_ITEM_TYPE.ACTION:
        item = Action;
        break;
      case INSPECTION_ITEM_TYPE.FORM_ACTION:
        item = FormAction;
        break;
      default:
        item = UnknownItem;
    }

    return h(item, {
      class: props.item.type,
      props,
    });
  },
};
